import { render } from "./classPurchase.vue?vue&type=template&id=af4abaa8&scoped=true&ts=true"
import script from "./classPurchase.vue?vue&type=script&lang=ts"
export * from "./classPurchase.vue?vue&type=script&lang=ts"

import "./classPurchase.vue?vue&type=style&index=0&id=af4abaa8&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af4abaa8"]])

export default __exports__